// extracted by mini-css-extract-plugin
export default {"mobile_menu":"MobileMenu_mobile_menu__rPgJg","list":"MobileMenu_list__fb6lA","items":"MobileMenu_items__f9Mhe","links":"MobileMenu_links__YVbud"};